const aLoadingSecondary = {
  aLoadingSecondary: {
    message: 'Cargando Datos...'
  }
}

export default aLoadingSecondary
